import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@twilio-paste/core";

import { Header } from "./Header";
import { MessageList } from "./MessageList";
import { MessageInput } from "./MessageInput";
import { AppState } from "../store/definitions";
import { ConversationEnded } from "./ConversationEnded";
import { NotificationBar } from "./NotificationBar";
import { removeNotification } from "../store/actions/genericActions";
import { notifications } from "../notifications";
import { AttachFileDropArea } from "./AttachFileDropArea";
import { wrapperStyle } from "./styles/MessagingCanvasPhase.styles";
import { isCurrentParticipantInConversation } from "../utils/conversations";

export const MessagingCanvasPhase = () => {
    const dispatch = useDispatch();
    const { conversationState, fileAttachmentConfig, participants, currentUserIdentity } = useSelector(
        (state: AppState) => ({
            conversationState: state.chat.conversationState,
            fileAttachmentConfig: state.config.fileAttachment,
            participants: state.chat.participants || [],
            currentUserIdentity: state.chat.conversationsClient?.user?.identity
        })
    );

    useEffect(() => {
        dispatch(removeNotification(notifications.failedToInitSessionNotification("ds").id));
    }, [dispatch]);

    const canCurrentUserMessage =
        conversationState !== "closed" && isCurrentParticipantInConversation(participants, currentUserIdentity);
    const Wrapper = canCurrentUserMessage && fileAttachmentConfig?.enabled ? AttachFileDropArea : Box;

    return (
        <Wrapper {...wrapperStyle} element="MESSAGING_CANVAS__WRAPPER">
            <Header />
            <NotificationBar />
            <MessageList />
            {canCurrentUserMessage ? <MessageInput /> : <ConversationEnded />}
        </Wrapper>
    );
};
